/**
 * Speurtocht Admin Layout
 */

import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function SpeurttochtAdminLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="create" />
      <Stack.Screen name="[id]/index" />
      <Stack.Screen name="[id]/steps" />
      <Stack.Screen name="[id]/add-step" />
      <Stack.Screen name="[id]/step/[stepId]" />
      <Stack.Screen name="[id]/progress" />
    </Stack>
  );
}

